// replaces all spaces with -
export const getComputerName = (str: string): string => {
  if (!str) return '';
  const computerName = str.replace(/\s+/g, '-').toLowerCase();
  return computerName;
};

export const truncateString = (str: string, limit: number): string => {
  if (!str) return '';
  let truncated = str.substring(0, limit);
  truncated += '...';
  return truncated;
};

export const normalizeInput = (value: string): string => {
  return value.toLowerCase().trim();
};

export const interpolateString = (str: string, ...args: string[]): string => {
  let interpolatedString = str;
  args.forEach((arg, index) => {
    interpolatedString = interpolatedString.replace(`{${index}}`, arg);
  });
  return interpolatedString;
};
